module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Italic.f76ec9f9.woff";